import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=94aa4d54"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports